import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation(["pages"]);

  const benefits = [
    "pages:home.cta.benefits.0",
    "pages:home.cta.benefits.1",
    "pages:home.cta.benefits.2",
    "pages:home.cta.benefits.3",
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden">
          {/* Left: Image with overlay text */}
          <div className="relative h-80 lg:h-auto min-h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/60fcbc59f302b2e3cf28d1b571d9b5e8.jpg"
              alt="Energy Infrastructure"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/40 to-transparent" />
            <div className="absolute bottom-8 left-8 right-8">
              <p className="text-emerald-300 text-xs font-semibold uppercase tracking-widest mb-2">
                {t("pages:home.cta.badge")}
              </p>
              <h3
                className="text-3xl md:text-4xl font-bold leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                <span className="italic text-emerald-300">
                  {t("pages:home.cta.title")}
                </span>
                <br />
                <span className="text-white">
                  {t("pages:home.cta.titleHighlight")}
                </span>
              </h3>
            </div>
          </div>

          {/* Right: CTA Content */}
          <div className="bg-white p-10 lg:p-14 flex flex-col justify-center">
            <h3
              className="text-3xl font-bold text-slate-900 mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t("pages:home.cta.heading")}
            </h3>
            <p className="text-slate-500 leading-relaxed mb-6">
              {t("pages:home.cta.description")}
            </p>
            <ul className="space-y-3 mb-8">
              {benefits.map((key, index) => (
                <li key={index} className="flex items-center gap-3 text-sm text-slate-700">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-check-line text-emerald-600 font-bold" />
                  </div>
                  {t(key)}
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer w-fit"
            >
              {t("pages:home.cta.button")}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}